function showCarSeats(state=false, action) {
  switch(action.type) {
    case "TOGGLE_CAR_SEATS" :
      return state = action.value;
    default :
      return state;
  }
}

export default showCarSeats;



/** WEBPACK FOOTER **
 ** ./src/reducers/showCarSeats.js
 **/